// extracted by mini-css-extract-plugin
module.exports = {"accordionDeal":"e_wp","buttonHolder":"e_xp","button":"e_yp"};